import { Box, InputGroup, InputLeftAddon, Input, TableContainer, Table, Thead, Tbody, Tr, Th, Td, useDisclosure, Badge, Stack, Button, Flex } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import DipendenteModal from './DipendenteModal';

const DipendentiTable = ({dipendenti, retrieveDipendenti}) => {

    const [selectedDipendente, setSelectedDipendente] = useState(null);
    const {isOpen, onOpen, onClose} = useDisclosure();
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredDipendenti, setFilteredDipendenti] = useState(dipendenti); // State for filtered dipendenti

    useEffect(() => {
        // Filter dipendenti based on the search query
        if(dipendenti != null){
            if(searchQuery === ""){
                var dipendentiFiltered = dipendenti;
            }else {
                var dipendentiFiltered = dipendenti.filter((dipendente) => {
                    const fullName = `${dipendente.name} ${dipendente.surname}`;
                    return fullName.toLowerCase().includes(searchQuery.toLowerCase());
                });
            }
            setFilteredDipendenti(dipendentiFiltered);
        }
    }, [searchQuery, dipendenti]);

    const handleRowClick = (dipendente) => {
        setSelectedDipendente(dipendente);
        onOpen();
    }
    
    return (
        <Box>
            <Flex justifyContent="space-between" alignItems="center" mb={4} gap={4}>
                <InputGroup attached w="full">
                    <InputLeftAddon>
                        <strong>Cerca dipendente: </strong>
                    </InputLeftAddon>
                    <Input
                        placeholder="Cerca dipendente..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </InputGroup>

                {/* <Button colorScheme="teal" onClick={onOpen}>
                    Aggiungi Dipendente
                </Button> */}
            </Flex>
            
            <TableContainer>
                <Table variant="simple">
                    <Thead>
                        <Tr>
                            <Th>Nome e Cognome</Th>
                            <Th>Contratto</Th>
                            <Th>Visita Medica</Th>
                            <Th>Corsi</Th>
                            <Th>Mansione attuale</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {filteredDipendenti.map((row) => (
                            <Tr key={row.id} onClick={() => handleRowClick(row)} cursor="pointer">
                                <Td>{row.name} {row.surname}</Td>
                                <Td>{row.contract}</Td>
                                <Td>{row.visita_medica}</Td>
                                <Td>
                                    <Stack direction='row'>
                                    {row.corsi.map((corso) => (
                                        <Badge>{corso.nome}</Badge>
                                    ))}
                                    </Stack>
                                </Td>
                                <Td>{row.mansione}</Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>

                {selectedDipendente && (
                    <DipendenteModal dipendente_id={selectedDipendente.id} isOpen={isOpen} onClose={onClose} retrieveDipendenti={retrieveDipendenti}/>
                )}
            </TableContainer>
        </Box>
    );
};

export default DipendentiTable;